import React, { memo } from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import UploadIcon from '@mui/icons-material/Upload';
import {
  ButtonContainer,
  ActionButton,
  UploadStatusRow,
  UploadStatusLabel,
} from './DynamicForm.styles.index';

const CONSTANTS = {
  BUTTON_LABELS: {
    REPLACE_FILE: 'Replace File',
    PROCEED: 'Proceed',
  },
  ARIA_LABELS: {
    REPLACE_BUTTON: 'Replace the uploaded file',
    PROCEED_BUTTON: 'Proceed with the uploaded file',
  },
  SUCCESS_LABEL: 'File uploaded successfully:',
} as const;

interface UploadedFilePanelProps {
  fileName: string;
  onReplace: () => void;
  onProceed: () => void;
  isExtracting?: boolean;
}

export const UploadedFilePanel: React.FC<UploadedFilePanelProps> = memo(
  ({ fileName, onReplace, onProceed, isExtracting = false }) => (
    <ButtonContainer role="group" aria-label="Uploaded file options">
      <ActionButton
        onClick={onReplace}
        variant="primary"
        icon={UploadIcon}
        disabled={isExtracting}
        aria-label={CONSTANTS.ARIA_LABELS.REPLACE_BUTTON}
      >
        {CONSTANTS.BUTTON_LABELS.REPLACE_FILE}
      </ActionButton>

      <UploadStatusRow role="status" aria-live="polite">
        <UploadStatusLabel>
          <CheckCircleOutlineIcon fontSize="small" />
          {CONSTANTS.SUCCESS_LABEL}
        </UploadStatusLabel>
        <span>{fileName}</span>
      </UploadStatusRow>

      <ActionButton
        onClick={onProceed}
        variant="primary"
        icon={ArrowForwardIcon}
        disabled={isExtracting}
        aria-label={CONSTANTS.ARIA_LABELS.PROCEED_BUTTON}
      >
        {isExtracting ? 'Extracting...' : CONSTANTS.BUTTON_LABELS.PROCEED}
      </ActionButton>
    </ButtonContainer>
  )
);

UploadedFilePanel.displayName = 'UploadedFilePanel';
